import { SettingsSort } from "./settings-sort"
import { ContentType } from "@/types/base"

export interface GeneralSettings {
  theme: string
  language: string
  notifications: boolean
}

export interface ContentSettings {
  sort: SettingsSort
}

export type SettingsState = {
  general: GeneralSettings
  content: Record<ContentType | "workspaces", ContentSettings>
}

export const getDefaultSettings = (): SettingsState => {
  return {
    general: {
      theme: "light",
      language: "en",
      notifications: true
    },
    content: {
      assistants: { sort: { mode: "alpha", order: "asc" } },
      chats: { sort: { mode: "timestamp", order: "desc" } },
      collections: { sort: { mode: "alpha", order: "asc" } },
      files: { sort: { mode: "alpha", order: "asc" } },
      groups: { sort: { mode: "alpha", order: "asc" } },
      mcps: { sort: { mode: "alpha", order: "asc" } },
      models: { sort: { mode: "alpha", order: "asc" } },
      presets: { sort: { mode: "alpha", order: "asc" } },
      profiles: { sort: { mode: "alpha", order: "asc" } },
      prompts: { sort: { mode: "alpha", order: "asc" } },
      providers: { sort: { mode: "alpha", order: "asc" } },
      tenants: { sort: { mode: "alpha", order: "asc" } },
      tools: { sort: { mode: "alpha", order: "asc" } },
      roles: { sort: { mode: "alpha", order: "asc" } },
			workspaces: { sort: { mode: "alpha", order: "asc" } }
    }
  }
}

export function mergeSettings<T extends object>(defaultSettings: T, savedSettings: Partial<T>): T {
  const merged = { ...defaultSettings } as T

  for (const key in defaultSettings) {
    if (Object.prototype.hasOwnProperty.call(savedSettings, key)) {
      const defaultValue = defaultSettings[key as keyof T]
      const savedValue = savedSettings[key as keyof T]

      if (typeof defaultValue === 'object' && defaultValue !== null && !Array.isArray(defaultValue)) {
        merged[key as keyof T] = mergeSettings(
          defaultValue,
          savedValue as Partial<typeof defaultValue>
        ) as unknown as T[keyof T]
      } else {
        merged[key as keyof T] = savedValue as T[keyof T]
      }
    }
  }

  return merged
}
